import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Botón único a Archivos del Han en el hero del territorio.
 */
export default function TerritoryHeroArchivesNav({ slug }) {
  if (!slug) return null

  const baseUrl = `/han/${encodeURIComponent(slug)}/archivos`

  return (
    <nav className="territory-hero__archives" aria-label="Archivos del Han">
      <Link to={baseUrl} className="territory-hero__archives-heading territory-hero__archives-heading--solo">
        <span className="territory-hero__archives-seal" aria-hidden="true" />
        <span className="territory-hero__archives-title">Archivos del Han</span>
        <span className="territory-hero__archives-arrow" aria-hidden="true">
          →
        </span>
      </Link>
    </nav>
  )
}
